import { combineReducers } from 'redux';
import { StudioAction, StudioState } from '../types';
import { Reducer } from '../../../types';
import {
  defaultSettings, defaultSettingsByUser, getSettings, saveSettings,
} from '../utils';
import {
  setOpenStudio,
  setGuideStudio,
  setAudioServiceTimeoutId,
  setAutoScrolling,
  setAverageCalibrateVolume,
  setBookmarkPosition,
  setConnectingAudioService,
  setFontSize,
  setRunningAudioService,
  setScrollIntervalId,
  setScrollSpeed,
  setTextStudio,
  setCalibratingAudioService,
  setAutoScrollAudioService,
  setBookmarkAction,
  setHomeAction,
  setPlayPrompter,
  setStartDelayTime,
  setCountdown,
  setCurrentCountdown,
  setOpenSettingsPanel,
  setSupportUserMedia,
  setSupportUserAudio,
  setMediaNotAvailable,
  setDropdownSelectMode,
  setStudioMode,
  setCameraRecording,
  setStudioMainContainerHeight,
  setStudioTopView,
  setStudioBottomView,
  setRecordCount,
  setCountdownCamera,
  setTeleprompterSync, setCameraId, setCameraReady, setCameraError, setAudioId,
} from '../actions';

type ReducerOf<T extends keyof StudioState> = Reducer<StudioState, StudioAction, T>;

const settingsStudio = getSettings();

const isOpen: ReducerOf<'isOpen'> = (state = false, action) => {
  switch (action.type) {
    case setOpenStudio.type:
      return action.payload;

    default:
      return state;
  }
};

const isOpenSettingsPanel: ReducerOf<'isOpenSettingsPanel'> = (state = settingsStudio.isOpenSettingsPanel, action) => {
  if (state === undefined) {
    state = true;
  }
  switch (action.type) {
    case setOpenSettingsPanel.type:
      return action.payload;

    default:
      return state;
  }
};


const guide: ReducerOf<'guide'> = (state = settingsStudio.guide || defaultSettings.guide, action) => {
  switch (action.type) {
    case setGuideStudio.type:
      return action.payload;

    default:
      return state;
  }
};

const text: ReducerOf<'text'> = (state = '', action) => {
  switch (action.type) {
    case setTextStudio.type:
      return action.payload;

    default:
      return state;
  }
};

const isAutoScrolling: ReducerOf<'isAutoScrolling'> = (state = false, action) => {
  switch (action.type) {
    case setAutoScrolling.type:
      return action.payload;

    default:
      return state;
  }
};

const isRunningAudioService: ReducerOf<'isRunningAudioService'> = (state = false, action) => {
  switch (action.type) {
    case setRunningAudioService.type:
      return action.payload;

    default:
      return state;
  }
};

const autoScrollAudioService: ReducerOf<'autoScrollAudioService'> = (state = false, action) => {
  switch (action.type) {
    case setAutoScrollAudioService.type:
      return action.payload;

    default:
      return state;
  }
};

const isConnectingAudioService: ReducerOf<'isConnectingAudioService'> = (state = false, action) => {
  switch (action.type) {
    case setConnectingAudioService.type:
      return action.payload;

    default:
      return state;
  }
};

const scrollSpeed: ReducerOf<'scrollSpeed'> = (state = defaultSettingsByUser.scrollSpeed, action) => {
  switch (action.type) {
    case setScrollSpeed.type:
      return parseFloat(action.payload.toFixed(1));

    default:
      return state;
  }
};

const fontSize: ReducerOf<'fontSize'> = (state = settingsStudio.fontSize || defaultSettings.fontSize, action) => {
  switch (action.type) {
    case setFontSize.type:
      return parseInt(action.payload.toString(), 10);

    default:
      return state;
  }
};
const mediaNotAvailable: ReducerOf<'mediaNotAvailable'> = (state = settingsStudio.mediaNotAvailable || defaultSettings.mediaNotAvailable, action) => {
  switch (action.type) {
    case setMediaNotAvailable.type:
      return action.payload;

    default:
      return state;
  }
};

const startDelayTime: ReducerOf<'fontSize'> = (state = settingsStudio.startDelayTime || defaultSettings.startDelayTime, action) => {
  switch (action.type) {
    case setStartDelayTime.type:
      return parseInt(action.payload.toString(), 10);

    default:
      return state;
  }
};

const scrollIntervalId: ReducerOf<'scrollIntervalId'> = (state = null, action) => {
  switch (action.type) {
    case setScrollIntervalId.type:
      return action.payload;

    default:
      return state;
  }
};

const audioServiceTimeoutId: ReducerOf<'audioServiceTimeoutId'> = (state = null, action) => {
  switch (action.type) {
    case setAudioServiceTimeoutId.type:
      return action.payload;

    default:
      return state;
  }
};

const bookmarkPosition: ReducerOf<'bookmarkPosition'> = (state = null, action) => {
  switch (action.type) {
    case setBookmarkPosition.type:
      return action.payload;

    default:
      return state;
  }
};

const averageCalibrateVolume: ReducerOf<'averageCalibrateVolume'> = (state = 0, action) => {
  switch (action.type) {
    case setAverageCalibrateVolume.type:
      return action.payload;

    default:
      return state;
  }
};

const isCalibratingAudioService: ReducerOf<'isCalibratingAudioService'> = (state = false, action) => {
  switch (action.type) {
    case setCalibratingAudioService.type:
      return action.payload;

    default:
      return state;
  }
};

const homeAction: ReducerOf<'homeAction'> = (state = true, action) => {
  switch (action.type) {
    case setHomeAction.type:
      return action.payload;

    default:
      return state;
  }
};

const bookmarkAction: ReducerOf<'bookmarkAction'> = (state = false, action) => {
  switch (action.type) {
    case setBookmarkAction.type:
      return action.payload;

    default:
      return state;
  }
};

const isPlayPrompter: ReducerOf<'isPlayPrompter'> = (state = false, action) => {
  switch (action.type) {
    case setPlayPrompter.type:
      return action.payload;

    default:
      return state;
  }
};

const cameraReady: ReducerOf<'cameraReady'> = (state = false, action) => {
  switch (action.type) {
    case setCameraReady.type:
      return action.payload;

    default:
      return state;
  }
};

const cameraError: ReducerOf<'cameraError'> = (state = false, action) => {
  switch (action.type) {
    case setCameraError.type:
      return action.payload;

    default:
      return state;
  }
};

const isCountdown: ReducerOf<'isCountdown'> = (state = false, action) => {
  switch (action.type) {
    case setCountdown.type:
      return action.payload;

    default:
      return state;
  }
};

const currentCountdown: ReducerOf<'currentCountdown'> = (state = 0, action) => {
  switch (action.type) {
    case setCurrentCountdown.type:
      return action.payload;

    default:
      return state;
  }
};


const isSupportUserMedia: ReducerOf<'isSupportUserMedia'> = (state = false, action) => {
  switch (action.type) {
    case setSupportUserMedia.type:
      return action.payload;

    default:
      return state;
  }
};

const isSupportUserAudio: ReducerOf<'isSupportUserAudio'> = (state = false, action) => {
  switch (action.type) {
    case setSupportUserAudio.type:
      return action.payload;

    default:
      return state;
  }
};

const isSelectDropdownOpen: ReducerOf<'isSelectDropdownOpen'> = (state = false, action) => {
  switch (action.type) {
    case setDropdownSelectMode.type:
      return action.payload;

    default:
      return state;
  }
};

const studioMode: ReducerOf<'studioMode'> = (state = settingsStudio.studioMode || defaultSettings.studioMode, action) => {
  switch (action.type) {
    case setStudioMode.type:
      saveSettings('studioMode', action.payload);
      return action.payload;

    default:
      return state;
  }
};

const isCameraRecording: ReducerOf<'isCameraRecording'> = (state = false, action) => {
  switch (action.type) {
    case setCameraRecording.type:
      return action.payload;

    default:
      return state;
  }
};

const mainContainerHeight: ReducerOf<'mainContainerHeight'> = (state = settingsStudio.mainContainerHeight || 0, action) => {
  switch (action.type) {
    case setStudioMainContainerHeight.type:
      return action.payload;

    default:
      return state;
  }
};


const studioTopView: ReducerOf<'studioTopView'> = (state = settingsStudio.studioTopView || defaultSettings.studioTopView, action) => {
  switch (action.type) {
    case setStudioTopView.type:
      saveSettings('studioTopView', action.payload);
      return action.payload;

    default:
      return state;
  }
};
const studioBottomView: ReducerOf<'studioBottomView'> = (state = settingsStudio.studioBottomView || defaultSettings.studioBottomView, action) => {
  switch (action.type) {
    case setStudioBottomView.type:
      saveSettings('studioBottomView', action.payload);
      return action.payload;

    default:
      return state;
  }
};

const recordCount: ReducerOf<'recordCount'> = (state = 1, action) => {
  switch (action.type) {
    case setRecordCount.type:
      return action.payload;

    default:
      return state;
  }
};

const isCountdownCamera: ReducerOf<'isCountdownCamera'> = (state = false, action) => {
  switch (action.type) {
    case setCountdownCamera.type:
      return action.payload;

    default:
      return state;
  }
};
const cameraId: ReducerOf<'cameraId'> = (state = settingsStudio.selectedCameraId || defaultSettings.selectedCameraId, action) => {
  switch (action.type) {
    case setCameraId.type:
      saveSettings('selectedCameraId', action.payload);
      return action.payload;

    default:
      return state;
  }
};

const audioId: ReducerOf<'audioId'> = (state = settingsStudio.selectedAudioId || defaultSettings.selectedAudioId, action) => {
  switch (action.type) {
    case setAudioId.type:
      saveSettings('selectedAudioId', action.payload);
      return action.payload;

    default:
      return state;
  }
};

const isTeleprompterSync: ReducerOf<'isTeleprompterSync'> = (state = settingsStudio.studioPrompterSync, action) => {
  if (state === undefined) {
    state = true;
  }
  switch (action.type) {
    case setTeleprompterSync.type:
      saveSettings('studioPrompterSync', action.payload);
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<StudioState>({
  isOpen,
  studioMode,
  isOpenSettingsPanel,
  isSupportUserMedia,
  isSupportUserAudio,
  isPlayPrompter,
  isCountdown,
  currentCountdown,
  guide,
  text,
  isAutoScrolling,
  autoScrollAudioService,
  isRunningAudioService,
  isConnectingAudioService,
  scrollSpeed,
  fontSize,
  mediaNotAvailable,
  startDelayTime,
  scrollIntervalId,
  audioServiceTimeoutId,
  bookmarkPosition,
  averageCalibrateVolume,
  isCalibratingAudioService,
  homeAction,
  bookmarkAction,
  isSelectDropdownOpen,
  isCameraRecording,
  mainContainerHeight,
  studioTopView,
  studioBottomView,
  recordCount,
  isCountdownCamera,
  isTeleprompterSync,
  cameraId,
  cameraReady,
  cameraError,
  audioId,
});
